export class Zuschlag {
  readonly dauer: number;
  readonly name: string;
  readonly prozent: number;
  readonly betrag?: number;

  constructor({
    dauer,
    name,
    prozent,
    betrag,
  }: {
    dauer: number;
    name: string;
    prozent: number;
    betrag?: number; // optional da nicht alle Manager den Betrag sehen dürfen.
  }) {
    this.dauer = dauer;
    this.name = name;
    this.prozent = prozent;
    this.betrag = betrag;
  }
}
